/**
 *
 * SubscriptionRequiredNotice
 *
 * The inline twin of ResubscribeModal, for the case where there is no control
 * to click: a canceled-subscription account that lands on /channels/new or
 * /channels/:id/edit directly — a bookmark, a pasted link, a browser-restored
 * tab. Gating only the buttons would leave those routes rendering a form whose
 * every save the server rejects, so the route renders this instead of the form.
 *
 * The way back is an explicit link rather than a redirect: a redirect from a
 * bookmarked URL looks like the bookmark broke, and says nothing about why.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { BackLink, Card } from './styledComponents';
import ResubscribeMessage from 'components/ResubscribeMessage';

const SubscriptionRequiredNotice = () => (
  <Card>
    <ResubscribeMessage />
    <BackLink>
      <Link to='/channels'>Back to channels</Link>
    </BackLink>
  </Card>
);

export default SubscriptionRequiredNotice;
